import XBButton from './XBButton';

export default XBButton;
